import axios from 'axios';
import { IComment } from '@/dealroom-view/chat/types/comment';
import { apolloClient } from '@/apollo';
import { ChatQueries } from '@/api/chat/graphql/chat.queries';
import { EFetchPolicy } from '@/api/types/enums/fetch-policy';
export class ChatService {
  static async getComments(documentId: string): Promise<IComment[]> {
    const {
      data: { comments },
    } = await apolloClient.query({
      query: ChatQueries.commentsQuery,
      variables: { documentId },
      fetchPolicy: EFetchPolicy.NetworkOnly,
    });
    return comments;
  }
  static async createComment(documentId: string, commentText: string): Promise<boolean> {
    const body: FormData = new FormData();
    body.append('action', 'comment');
    body.append('document-id', documentId);
    body.append('comment_text', commentText);

    const { data } = await axios.post(`/save/document`, body);
    if (data.status === 1) {
      return true;
    }
    throw new Error(data.error);
  }
  static async deleteComment(documentId: string, commentId: string): Promise<boolean> {
    const body: FormData = new FormData();
    body.append('action', 'comment-delete');
    body.append('document-id', documentId);
    body.append('comment-id', commentId);
    const { data } = await axios.post(`/save/document`, body);
    if (data.status === 1) {
      return true;
    }
    throw new Error(data.error);
  }
}
